import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

/** EPO import — confirm same-day GB arrival before continuing past Date of Arrival. */
function SameDayArrivalModal({ show, onCancel, onConfirm, arrivalDateUk }) {
  return (
    <Modal show={show} onHide={onCancel} centered animation={false}>
      <Modal.Header>
        <Modal.Title>Same Day Arrival</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onCancel} />
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0" style={{ color: '#000' }}>
          Please confirm these goods will arrive today {arrivalDateUk}.
        </p>
      </Modal.Body>
      <Modal.Footer
        className="d-flex flex-row py-3 px-3 gap-3 border-top bg-light justify-content-between align-items-center"
        style={{ borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
      >
        <button type="button" className="stepper-button red" onClick={onCancel} style={{ borderRadius: '10px' }}>
          Cancel
        </button>
        <button type="button" className="stepper-button" onClick={onConfirm} style={{ borderRadius: '10px' }}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
}

SameDayArrivalModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  arrivalDateUk: PropTypes.string.isRequired,
};

export default SameDayArrivalModal;
